import $ from 'jquery'
import { config } from '../config.js'
const API = config.apiUrl

export default () => {
    fetch(API + 'investor/intercom_fields', {
        method: 'GET',
        headers: {},
        cache: 'no-store',
        credentials: 'include',
    })
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText)
            }
            return response
        })
        .then(response => response.json())
        .then(obj => {
            var appId = 'igb92dwc',
                intercomSettings = { app_id: appId }

            intercomSettings = {
                app_id: appId,
                user_id: obj.id,
                name: obj.firstname + ' ' + obj.lastname,
                eth_address: obj.eth_address,
                user_hash: obj.hash_hmac,
                email: obj.email,
            }
            window.intercomSettings = intercomSettings
            ;(function() {
                var w = window
                var ic = w.Intercom
                if (typeof ic === 'function') {
                    ic('reattach_activator')
                    ic('update', intercomSettings)
                } else {
                    var d = document
                    var i = function() {
                        i.c(arguments)
                    }
                    i.q = []
                    i.c = function(args) {
                        i.q.push(args)
                    }
                    w.Intercom = i

                    $(document).ready(function() {
                        console.log('intercom loading 1')
                        var s = d.createElement('script')
                        s.type = 'text/javascript'
                        s.async = true
                        s.src = 'https://widget.intercom.io/widget/igb92dwc'
                        var x = d.getElementsByTagName('script')[0]
                        x.parentNode.insertBefore(s, x)
                    })
                }
            })()
        })
        .catch(err => {
            throw Error(err.message).stack
        })
}
